import {
	format as formatDateFns,
	formatInTimeZone,
	zonedTimeToUtc,
} from "date-fns-tz";
import { isNil } from "lodash-es";
import moment from "moment-timezone";
import { findIana } from "windows-iana";

export class TimeService {
	private static instance: TimeService;
	private timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;

	private constructor() {}

	public static getInstance(): TimeService {
		if (!TimeService.instance) {
			TimeService.instance = new TimeService();
		}
		return TimeService.instance;
	}

	public setTimeZone(timeZone: string) {
		const ianaTimeZones = findIana(timeZone);
		if (ianaTimeZones.length) {
			this.timeZone = ianaTimeZones[0];
		} else {
			this.timeZone = timeZone;
		}
		moment.tz.setDefault(this.timeZone);
	}

	public toUTC(datetime: Date | string, format: string) {
		try {
			if (datetime instanceof Date) {
				return formatDateFns(datetime, format);
			}
			return formatDateFns(
				zonedTimeToUtc(datetime, TimeService.instance.timeZone),
				format,
			);
		} catch (e) {
			console.log({ datetime: datetime, e });
			return "";
		}
	}

	public toLocalServerTime(
		datetime: Date | string | null | undefined,
		format: string,
	) {
		try {
			if (isNil(datetime) || !datetime) {
				return "";
			}
			if (typeof datetime === "string") {
				if (datetime.includes("Z")) {
					datetime = new Date(datetime);
				} else {
					datetime = new Date(`${datetime}Z`);
				}
			}
			return formatInTimeZone(datetime, TimeService.instance.timeZone, format);
		} catch (e) {
			console.log({ datetime: datetime, e });
			return "";
		}
	}

	public getServerTimeZone() {
		return this.timeZone;
	}
}

export const getMomentTz = () => moment;
export const dxtServerTimeZone = () =>
	TimeService.getInstance().getServerTimeZone;
export const dxtToUTC = TimeService.getInstance().toUTC;
export const dxtToLocalServerTime = TimeService.getInstance().toLocalServerTime;
